
function MobileNavDirective(shopPageStateService, panelOverride, loginService, shopperService, globalHeaderPanelService, breakpointsService, $timeout, $state, catalogService, settingsService) {
	return {
		template: require('./mobile-nav-template.html'),
		restrict: 'EA',
		link(scope, elem) {

			scope.panelOverride = panelOverride;
			scope.shopper = shopperService;
			scope.selectedCategory = null;
			scope.isSubPanelOpen = false;
            scope.categories = catalogService.topLevelCategories;
			scope.isDropNavEnabled = false;
			scope.isPremixNavEnabled = false;
			scope.isMeganavReadyToRender = false;
			settingsService.getFrontendSetting('Menunav', 'menunavpremix').then((response) => {
                if (response) {
					scope.isPremixNavEnabled = response[0] ? JSON.parse(response[0].Value) : false;
                    if (scope.isPremixNavEnabled) {
                       scope.categories.find(item => item.Attributes.content_display === 'PremixMenuNavPromotion').Attributes.isEnabled = true;
                    }
                }
            });
			scope.isLoginPanelOpen = function () {
				return breakpointsService.isSmallFormat && globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.login);
			};

			scope.isRegisterOpen = function () {
				return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.signup);
			};

			scope.isPasswordResetOpen = function () {
				return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.resetpassword);
			};

			scope.isOverlayOpen = function () {
				return scope.isLoginPanelOpen() || scope.isRegisterOpen() || scope.isPasswordResetOpen();
			};

			scope.openSubPanel = function (category) {
				if (category.Attributes && category.Attributes.web_link) {
					if (shopPageStateService.panels.left) {
						shopPageStateService.togglePanel('left');
					}
					$timeout(() => {
						$state.go(category.Attributes.web_link, {}, { reload: true });
					}, 0);
					return;
				}
				$timeout(() => {
					scope.selectedCategory = category;
					scope.isSubPanelOpen = true;
				}, 0);
			};

			scope.closeSubPanel = function () {
				scope.selectedCategory = null;
				scope.isSubPanelOpen = false;
			};

			scope.$on('headerPanel:open', () => {
				elem.find('.globalHeader-mobileNav').scrollTop(0);
			});

			scope.closeMenu = function () {
				globalHeaderPanelService.closePanel();
			};

			scope.logout = function () {
                scope.logoutLoading = true;
                loginService.logout();
			};

			scope.goToSignup = function () {
				globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.signup);
			};

			scope.getUrl = function (category, childCategory) {
				return scope.stateOptions.state + '({ ' + scope.stateOptions.category + ': "' + category.UrlFriendlyName + '", ' + scope.stateOptions.subCategory + ': "' + childCategory.UrlFriendlyName + '", name: undefined, productId: undefined, recipeId: undefined, cardId: undefined, pageNumber: undefined})';
			};

			scope.getDepartmentUrl = function (category) {
				return scope.stateOptions.state + '({ ' + scope.stateOptions.category + ': "' + category.UrlFriendlyName + '"})';
			};

			scope.openPanel = function (panel) {
				globalHeaderPanelService.openPanel(panel);
			};

			scope.isNavMenuPanelOpen = function () {
				return breakpointsService.isSmallFormat && globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.browse);
			};

			scope.isSmallFormat = breakpointsService.isSmallFormat();

			scope.closePanel = function () {
				if (!scope.isOverlayOpen()) {
					shopPageStateService.panels.left = false;
				} else {
					globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.none);
				}
			};

			scope.$watch('panelOverride.isOpen', (isOpen) => {
				const bwsRoot = document.getElementById('bwsbot_root');
				if (isOpen) {
					if (bwsRoot) {
                        bwsRoot.style.visibility = 'hidden';
                    }
					globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.none);
					scope.isSubPanelOpen = false;
					scope.selectedCategory = null;
				} else {
                    if (bwsRoot) {
                        bwsRoot.style.visibility = 'visible';
                    }
                }
			});

            settingsService.getFrontendSetting('MenuNav', 'IsAemMegaNavEnabled')
                .then((res) => {
                    if (res && res[0] && res[0].Value === 'true') {
                        scope.isAemMegaNavEnabled = true;
                    }
                    scope.isMeganavReadyToRender = true;
                }).catch(() => {
                    scope.isMeganavReadyToRender = true;
                });
		}
	};
}

module.exports = MobileNavDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/mobile-nav-directive.js
 **/